module.exports = __webpack_public_path__ + "static/img/6190_phase_function_Paper_PointsHejduk_Prediction.cf4831c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6190_phase_function_Paper_PointsHejduk_Prediction.png
// module id = JHrY
// module chunks = 0